
$(document).ready(function() {
    
    $(window).scroll(function() {
        if ($(this).scrollTop() > 300) {
            $('.theme-header').addClass('sticky-header');
        } else {
            $('.theme-header').removeClass('sticky-header');
        }
    });
        $('#navbarNav .navbar-nav li').each(function(){
            if($(this).hasClass('menu-item-has-children')){
                $(this).append('<span class="drop-icon">▼</span>');
            }
        });
        
        $(document).on('click', '#navbarNav .navbar-nav li .drop-icon', function(e){
            e.preventDefault();
            if($(this).hasClass('rotate')) {
                $(this).prev('ul').slideUp();
                $(this).removeClass('rotate');
            }
           else{
             $(this).prev('ul').slideDown();
                $(this).addClass('rotate');
           }
        });

    $('img').each(function() {
        if (!$(this).attr('alt') || $(this).attr('alt').trim() === "") {
            var src = $(this).attr('src');
            if (src) {
                var fileName = src.split('/').pop().split('.').shift();
                $(this).attr('alt', fileName);
            }
        }
    });


    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
});

